import { Descriptions, Button, Modal, Input, Form, TimePicker } from "antd";
import { useState, useEffect, useRef } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat) // 브라우저마다 지원하는 형식이 달라서 일관된 결과를 얻기 위해서는 해줘야만 한다.

const backend = process.env.REACT_APP_BACKEND;

function TimeSetting({ timeSetting, timeHandler }) {
  const dispatch = useDispatch();
  const [dayStartTime, setDayStartTime] = useState(false);
  const [emailExpireTime, setEmailExpireTime] = useState(false);
  const [freeTrial, setFreeTrial] = useState(false);
  const timeRef = useRef(null);

  function changeTime() {
    setDayStartTime(true);
  }
  function changeEmailExpireTime() {
    setEmailExpireTime(true);
  }
  function changeFreeTrial() {
    setFreeTrial(true);
  }

  function resetValue() {
    timeRef.current.resetFields();
  }

  function editOkHandler() {
    const key = Object.keys(timeRef.current.getFieldsValue())[0];

    let value = JSON.parse(JSON.stringify(timeSetting));

    if (key === "day_start_time") {
      const newTime = timeRef.current
        .getFieldsValue()
        .day_start_time.format("HH:mm:ss");

      value.day_start_time = newTime;
    }

    if (key === "email_auth_code_expire_time_second") {
      const newEmailExpire =
        timeRef.current.getFieldsValue().email_auth_code_expire_time_second;

      value.email_auth_code_expire_time_second = Number(newEmailExpire);
    }

    if (key === "free_trial_day") {
      const newEmailExpire = timeRef.current.getFieldsValue().free_trial_day;

      value.free_trial_day = Number(newEmailExpire);
    }

    // console.log(value);

    axios
      .post(`${backend}/general_setting/time_setting`, { value })
      .then((data) => {
        // const tempTimeSetting = JSON.parse(JSON.stringify(timeSetting));
        // tempTimeSetting.day_start_time = newTime;

        // console.log(tempTimeSetting);
        timeHandler(value);
        setDayStartTime(false);
        setEmailExpireTime(false);
        setFreeTrial(false);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          Modal.error({
            title: "인증 에러",
            content: "인증이 만료되었습니다. 다시 로그인 해주세요.",
            afterClose: () => {
              dispatch(authAction(false, null));
            },
          });
        }
        console.log(err);
      });
  }

  function editCancelHandler() {
    setDayStartTime(false);
    setEmailExpireTime(false);
    setFreeTrial(false);
  }

  return (
    <div>
      <Modal
        destroyOnClose={true}
        open={dayStartTime}
        title="시각 설정"
        maskClosable={false}
        onCancel={editCancelHandler}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button onClick={resetValue}>내용 초기화</Button>
            <span>
              <Button type="primary" onClick={editOkHandler}>
                수정
              </Button>
              <Button onClick={editCancelHandler}>취소</Button>
            </span>
          </div>
        }
      >
        {/* <Test></Test> */}
        <Form
          ref={timeRef}
          layout="vertical"
          initialValues={{
            day_start_time: dayjs(timeSetting.day_start_time, "HH:mm:ss"),
          }}
        >
          <Form.Item name="day_start_time" label="하루 시작 시각">
            <TimePicker />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        destroyOnClose={true}
        open={emailExpireTime}
        title="시각 설정"
        maskClosable={false}
        onCancel={editCancelHandler}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button onClick={resetValue}>내용 초기화</Button>
            <span>
              <Button type="primary" onClick={editOkHandler}>
                수정
              </Button>
              <Button onClick={editCancelHandler}>취소</Button>
            </span>
          </div>
        }
      >
        {/* <Test></Test> */}
        <Form
          ref={timeRef}
          layout="vertical"
          initialValues={{
            email_auth_code_expire_time_second:
              timeSetting.email_auth_code_expire_time_second,
          }}
        >
          <Form.Item
            name="email_auth_code_expire_time_second"
            label="이메일 인증코드 유효시간(초)"
            rules={[
              { required: true, message: "입력값은 필수입니다." },
            ]}
          >
            <Input type={"number"}/>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        destroyOnClose={true}
        open={freeTrial}
        title="시각 설정"
        maskClosable={false}
        onCancel={editCancelHandler}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button onClick={resetValue}>내용 초기화</Button>
            <span>
              <Button type="primary" onClick={editOkHandler}>
                수정
              </Button>
              <Button onClick={editCancelHandler}>취소</Button>
            </span>
          </div>
        }
      >
        {/* <Test></Test> */}
        <Form
          ref={timeRef}
          layout="vertical"
          initialValues={{ free_trial_day: timeSetting.free_trial_day }}
        >
          <Form.Item
            name="free_trial_day"
            label="무료사용기간(일)"
            rules={[
              // { type: "number", message: "숫자로 입력하세요" },
              { required: true, message: "입력값은 필수입니다." },
            ]}
          >
            <Input type="number"/>
          </Form.Item>
        </Form>
      </Modal>

      <Descriptions column={1} bordered={true} style={{width: 500}}>
        <Descriptions.Item label="하루 시작 시각" style={{textAlign:"left"}}>
          <span style={{ marginRight: "10px" }}>
            {dayjs(timeSetting.day_start_time, "HH:mm:ss").format(
              "HH시 mm분 ss초"
            )}
          </span>
          <Button size="small" onClick={changeTime}>
            변경
          </Button>
        </Descriptions.Item>
        <Descriptions.Item label="이메일 인증코드 유효시간" style={{textAlign:"left"}}>
          <span style={{ marginRight: "10px" }}>
            {timeSetting.email_auth_code_expire_time_second}초
          </span>
          <Button size="small" onClick={changeEmailExpireTime}>
            변경
          </Button>
        </Descriptions.Item>
        <Descriptions.Item label="무료사용기간" style={{textAlign:"left"}}>
          <span style={{ marginRight: "10px" }}>
            {timeSetting.free_trial_day}일
          </span>
          <Button size="small" onClick={changeFreeTrial}>
            변경
          </Button>
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
}

export default TimeSetting;
